export const environment = {
  production: true,
  apiUrl: 'https://us-central1-iplanta-prod.cloudfunctions.net/api/',
  // URL pública do hosting, usada para montar links de compartilhamento.
  // Domínio próprio do cliente (aponta para o site de hosting iplanta-prod),
  // para que os links não quebrem se o projeto Firebase mudar de novo.
  pwaUrl: 'https://app.iplanta.com.br',
  firebase: {
    apiKey: 'AIzaSyA4JOBrtiETa-V2NLVNtegKpxXRoJbigRc',
    authDomain: 'iplanta-prod.firebaseapp.com',
    projectId: 'iplanta-prod',
    storageBucket: 'iplanta-prod.firebasestorage.app',
    messagingSenderId: '103706943771',
    appId: '1:103706943771:web:57e757f306571ef9e833be',
  },
  // Google OAuth Web client ID (for web platform)
  googleClientId: '103706943771-81ntdbm2b1cthd83n5qmuutuo3imkt73.apps.googleusercontent.com',
  // Google OAuth Web client ID for Android native (from google-services.json client_type: 3)
  googleAndroidClientId: '103706943771-81ntdbm2b1cthd83n5qmuutuo3imkt73.apps.googleusercontent.com',
  // Google OAuth iOS client ID (from GoogleService-Info.plist CLIENT_ID)
  googleIosClientId: '103706943771-7gnb4l0a4orivt6eru6hoasovs1llomj.apps.googleusercontent.com',
};
